import { render, staticRenderFns } from "./NgVideoTag.vue?vue&type=template&id=b1629476&scoped=true&"
import script from "./NgVideoTag.vue?vue&type=script&lang=js&"
export * from "./NgVideoTag.vue?vue&type=script&lang=js&"
import style0 from "./NgVideoTag.vue?vue&type=style&index=0&id=b1629476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1629476",
  null
  
)

export default component.exports